module.exports = __webpack_public_path__ + "assets/arrow-down.d7191820.svg";